import { module } from "angular";
import { LoginFormComponent } from "./LoginFormComponent";

module("mmAuth").component("mmLoginForm", new LoginFormComponent());
